/**
 * The sign-in window's second step, after the email.
 *
 * auth.sendVerificationCode answers `signInWith: "password"` for the store
 * review accounts (APP_REVIEW_EMAILS while APP_REVIEW_CODE is set): reviewers
 * hold a username and password and are emailed nothing, so the window asks for
 * the password instead of saying "check your email". Everyone else gets the
 * emailed six-digit code.
 */

export type SignInStep = "code" | "password";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

/**
 * Reads the step from sendVerificationCode's tRPC reply body, with or without
 * the superjson `json` wrapper. Anything else, such as a server from before
 * the field existed, is the emailed-code step.
 */
export function signInStepFromReply(body: unknown): SignInStep {
  const data = isRecord(body) && isRecord(body.result) ? body.result.data : undefined;
  const payload = isRecord(data) && isRecord(data.json) ? data.json : data;
  return isRecord(payload) && payload.signInWith === "password" ? "password" : "code";
}
